import { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Cadastro from './pages/Cadastro'
import RecuperarSenha from './pages/RecuperarSenha'
import NovaSenha from './pages/NovaSenha'
import Ligas from './pages/Ligas'
import Picks from './pages/Picks'
import Placar from './pages/Placar'
import Ranking from './pages/Ranking'
import Grade from './pages/Grade'
import Historico from './pages/Historico'
import Estatisticas from './pages/Estatisticas'
import Noticias from './pages/Noticias'
import Admin from './pages/Admin'
import Regulamento from './pages/Regulamento'
import Pagamento from './pages/Pagamento'
import Perfil from './pages/Perfil'
import Logo from './components/Logo'

function RotaProtegida({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div style={loadingStyle}>Carregando...</div>
  if (!user) return <Navigate to="/login" />
  return children
}

function RotaPublica({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div style={loadingStyle}>Carregando...</div>
  if (user) return <Navigate to="/" />
  return children
}

function RotaComLiga({ children }) {
  const { user, loading, ligaAtual, minhasLigas } = useAuth()
  if (loading) return <div style={loadingStyle}>Carregando...</div>
  if (!user) return <Navigate to="/login" />
  // Se não tem liga selecionada e tem ligas, vai para seleção
  if (!ligaAtual) return <Navigate to="/ligas" />
  return children
}

function Layout({ children }) {
  const { usuario, ligaAtual, membroAtual, minhasLigas, signOut, trocarLiga } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [showLigas, setShowLigas] = useState(false)

  const abas = [
    { path: '/', label: 'Picks' },
    { path: '/placar', label: 'Placar da Rodada' },
    // { path: '/ranking', label: 'Ranking Simplificado' }, // oculta - reativar se precisar
    { path: '/grade', label: 'Ranking' },
    // { path: '/historico', label: 'Histórico' }, // integrado na aba Picks
    { path: '/estatisticas', label: 'Estatísticas' },
    { path: '/noticias', label: 'Notícias' },
    { path: '/regulamento', label: 'Regulamento' },
    { path: '/pagamento', label: '💳 Pagamento' },
    ...(membroAtual?.is_admin || ligaAtual?.criado_por === usuario?.id ? [{ path: '/admin', label: 'Admin' }] : []),
  ]

  async function handleSair() {
    await signOut()
    navigate('/login')
  }

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '.75rem' }}>
      {/* Header */}
      <div style={topBar}>
        <div style={logoStyle}>
          <Logo size={56} />
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'white', letterSpacing: 0.5 }}>NFL Survival</div>
            {/* Seletor de liga */}
            <div style={{ position: 'relative' }}>
              <button style={ligaBtn} onClick={() => setShowLigas(!showLigas)}>
                {ligaAtual?.nome || 'Selecionar liga'} {minhasLigas.length > 1 ? '▾' : ''}
              </button>
              {showLigas && minhasLigas.length > 1 && (
                <div style={ligaDropdown}>
                  {minhasLigas.map(l => (
                    <button key={l.id} style={{ ...ligaDropdownItem, ...(l.id === ligaAtual?.id ? ligaDropdownItemAtivo : {}) }}
                      onClick={() => { trocarLiga(l.id); setShowLigas(false) }}>
                      {l.nome}
                    </button>
                  ))}
                  <button style={{ ...ligaDropdownItem, borderTop: '0.5px solid rgba(255,255,255,0.2)', marginTop: 4, paddingTop: 8 }}
                    onClick={() => { navigate('/ligas'); setShowLigas(false) }}>
                    + Ver todas as ligas
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
          {usuario?.primeiro_nome && (
            <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.55)', letterSpacing: 0.2 }}>
              {usuario.primeiro_nome} {usuario.ultimo_nome}
            </span>
          )}
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
              <button onClick={() => navigate('/perfil')} style={perfilBtn} title="Meu perfil">👤</button>
              {!usuario?.time_favorito && <span style={badgeTime} />}
            </div>
            <button onClick={handleSair} style={sairBtn}>Sair</button>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={navStyle}>
        {abas.map(aba => {
          const ativo = location.pathname === aba.path
          return (
            <button key={aba.path} style={{ ...navBtn, ...(ativo ? navBtnAtivo : {}) }} onClick={() => navigate(aba.path)}>
              {aba.label}
            </button>
          )
        })}
      </nav>

      {!usuario?.time_favorito && (
        <div style={bannerTime} onClick={() => navigate('/perfil')}>
          <span>🏈</span>
          <span style={{ fontSize: 12, fontWeight: 500, color: '#7A4F0E', flex: 1 }}>Escolha seu time favorito</span>
          <span style={bannerTimeBtn}>Escolher →</span>
        </div>
      )}

      <div key={ligaAtual?.id}>{children}</div>
    </div>
  )
}

function RotaMortosVivos() {
  const { user, loading } = useAuth()
  if (loading) return <div style={loadingStyle}>Carregando...</div>
  if (user) return <Navigate to="/ligas" />
  return <Navigate to="/cadastro" />
}

function AguardandoAprovacao() {
  const { signOut } = useAuth()
  const navigate = useNavigate()
  async function handleVoltar() { await signOut(); navigate('/login') }
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: '#f5f5f5' }}>
      <div style={{ background: 'white', borderRadius: 12, padding: '2rem', maxWidth: 380, textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: 48, marginBottom: '1rem' }}>⏳</div>
        <h2 style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>Cadastro recebido!</h2>
        <p style={{ fontSize: 13, color: '#666', marginBottom: '1.5rem' }}>
          Sua inscrição está aguardando aprovação do comissário. Assim que aprovado, você receberá acesso à liga.
        </p>
        <button onClick={handleVoltar} style={{ background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, cursor: 'pointer' }}>
          Voltar ao login
        </button>
      </div>
    </div>
  )
}

const loadingStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#666' }
const topBar = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '.6rem .75rem', background: '#0A2342', marginBottom: '0', borderRadius: '10px 10px 0 0', position: 'relative' }
const logoStyle = { display: 'flex', alignItems: 'center', gap: 10 }
const ligaBtn = { background: 'none', border: 'none', color: 'rgba(255,255,255,0.75)', fontSize: 11, cursor: 'pointer', padding: 0, textAlign: 'left', letterSpacing: 0.3 }
const ligaDropdown = { position: 'absolute', top: '100%', left: 0, background: '#0A2342', border: '0.5px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '6px 4px', zIndex: 100, minWidth: 180, boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }
const ligaDropdownItem = { display: 'block', width: '100%', padding: '7px 12px', background: 'none', border: 'none', color: 'rgba(255,255,255,0.8)', fontSize: 12, cursor: 'pointer', textAlign: 'left', borderRadius: 4 }
const ligaDropdownItemAtivo = { color: '#D85A30', fontWeight: 600 }
const sairBtn = { background: 'none', border: '0.5px solid rgba(255,255,255,0.3)', borderRadius: 8, padding: '5px 14px', cursor: 'pointer', fontSize: 13, color: 'white' }
const perfilBtn = { background: 'none', border: '0.5px solid rgba(255,255,255,0.3)', borderRadius: 8, padding: '5px 10px', cursor: 'pointer', fontSize: 14, color: 'white' }
const navStyle = { display: 'flex', gap: 2, marginBottom: '1rem', background: '#0A2342', borderRadius: '0 0 10px 10px', padding: '4px 4px 6px', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }
const navBtn = { flexShrink: 0, padding: '7px 11px', border: 'none', background: 'transparent', borderRadius: 5, fontSize: 12, color: 'rgba(255,255,255,0.6)', cursor: 'pointer', whiteSpace: 'nowrap' }
const navBtnAtivo = { background: '#D85A30', color: '#ffffff', fontWeight: 500 }
const bannerTime = { display: 'flex', alignItems: 'center', gap: 10, background: '#FAEEDA', border: '0.5px solid #BA7517', borderRadius: 8, padding: '9px 12px', marginBottom: '1rem', cursor: 'pointer' }
const bannerTimeBtn = { fontSize: 11, fontWeight: 500, color: '#7A4F0E', background: 'white', border: '0.5px solid #BA7517', borderRadius: 6, padding: '4px 9px', flexShrink: 0 }
const badgeTime = { position: 'absolute', top: 2, right: 2, width: 8, height: 8, background: '#D85A30', borderRadius: '50%', border: '1.5px solid #0A2342', display: 'block' }

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<RotaPublica><Login /></RotaPublica>} />
          <Route path="/cadastro" element={<RotaPublica><Cadastro /></RotaPublica>} />
          <Route path="/recuperar-senha" element={<RotaPublica><RecuperarSenha /></RotaPublica>} />
          <Route path="/nova-senha" element={<NovaSenha />} />
          <Route path="/ligas" element={<RotaProtegida><Ligas /></RotaProtegida>} />
          <Route path="/mortosvivos2026" element={<RotaMortosVivos />} />
          <Route path="/aguardando" element={<AguardandoAprovacao />} />
          <Route path="/" element={<RotaComLiga><Layout><Picks /></Layout></RotaComLiga>} />
          <Route path="/placar" element={<RotaComLiga><Layout><Placar /></Layout></RotaComLiga>} />
          <Route path="/ranking" element={<RotaComLiga><Layout><Ranking /></Layout></RotaComLiga>} />
          <Route path="/grade" element={<RotaComLiga><Layout><Grade /></Layout></RotaComLiga>} />
          <Route path="/historico" element={<RotaComLiga><Layout><Historico /></Layout></RotaComLiga>} />
          <Route path="/estatisticas" element={<RotaComLiga><Layout><Estatisticas /></Layout></RotaComLiga>} />
          <Route path="/noticias" element={<RotaComLiga><Layout><Noticias /></Layout></RotaComLiga>} />
          <Route path="/regulamento" element={<RotaComLiga><Layout><Regulamento /></Layout></RotaComLiga>} />
          <Route path="/admin" element={<RotaComLiga><Layout><Admin /></Layout></RotaComLiga>} />
          <Route path="/pagamento" element={<RotaComLiga><Layout><Pagamento /></Layout></RotaComLiga>} />
          <Route path="/perfil" element={<RotaProtegida><Layout><Perfil /></Layout></RotaProtegida>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
